<template>
<div class="bbwriteoffList">
    <div class="filters">
        <div class="add">
            <el-button type="primary" @click="handleAllWriteoff" v-if="['0'].indexOf(param.status)>-1">批量核销</el-button>
            <el-button type="success" @click="handleWriteoffCode" v-if="['0'].indexOf(param.status)>-1">总核销码</el-button>
        </div>
        <div class="search">
            <el-input v-model="param.orderno" placeholder="订单号" class="condition" clearable></el-input>
            <el-input v-model="param.title" placeholder="活动名称" class="condition" clearable></el-input>
            <el-input v-model="param.customername" placeholder="用户昵称" class="condition" clearable></el-input>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%" ref="multipleTable"
                  @select="handleSelectionChange" @select-all="handleAllSelectionChange" @row-click="handleRowChange">
            <el-table-column type="selection" width="50" v-if="['0'].indexOf(param.status)>-1"></el-table-column>
            <el-table-column prop="voucherid" label="订单号" class-name="title" min-width="120px"></el-table-column>
            <el-table-column prop="subject" label="用户信息" class-name="center" min-width="120px">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img class="img" v-lazy="scope.row.userlogo " :alt="scope.row.username"
                             preview="LeaderList">
                        <span>{{scope.row.username }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="eventname" label="活动名称" class-name="center" min-width="250px"></el-table-column>
            <el-table-column prop="ordermoney" label="支付金额" class-name="center" min-width="80px">
                <template slot-scope="scope">￥{{scope.row.ordermoney}}</template>
            </el-table-column>
            <el-table-column prop="datatime" label="订单时间" class-name="center" min-width="120px"></el-table-column>
            <el-table-column prop="brokeragerateheader" label="订单状态" class-name="center">
                <template slot-scope="scope">
                    <span :class="scope.row.ischeck?'tc-green':'tc-orange'">{{scope.row.ischeck ? '已核销': '待核销'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="100px" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                    <span class="separator-btn" v-if="param.status!=1">
                        <el-button @click.stop="handleWriteoff(scope.row)" type="text" size="small">核销</el-button>
                    </span>
                        <span class="separator-btn">
                        <el-button @click.stop="handleView(scope.row)" type="text" size="small">详情</el-button>
                    </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @current-change="_getList" :current-page.sync="page.page"
                       :page-size="page.pageSize"
                       :pager-count="11" layout="prev, pager, next" :total="total">
        </el-pagination>
    </div>
    <writeoffCodeDialog ref="writeoffCodeDialog"></writeoffCodeDialog>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getCheckOrderInfoListByHost, uploadOrderCheckResult, getMPPosterInfo} from 'api/brandBusiness'
import {brandBusiness} from 'api/enumCode'
import WriteoffCodeDialog from 'views/brandBusiness/activityMgt/writeoff/components/writeoffCodeDialog.vue'
export default {
    name: 'writeoffList',
    data() {
        return {
            tableData: [],
            init: false,
            total: 0,
            statusList: brandBusiness.orderStatus,
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0
            },
            timeSlot: null,
            param: {
                customername: '',
                orderno: '',
                status: '',
                title: ''
            },
            selectedId: [],
            writeoffCode: ''
        }
    },
    mounted() {
    },
    methods: {
        initParam() {
            this.param = {
                customername: '',
                orderno: '',
                status: '',
                title: ''
            }
            this.page.page = 1
            this.timeSlot = null
            this.selectedId = []
            this.init = false
        },
        handleView(row) {
            this.$router.push({name: 'BBOrderView', query: {eventid:row.eventid, orderno: row.voucherid}})
        },
        handleWriteoffCode() {
            if (this.writeoffCode) {
                this.$refs.writeoffCodeDialog.openDialog(data.data, this.writeoffCode)
            } else {
                this.setLoading(true)
                getMPPosterInfo({
                    data: {
                        postertype: 25,
                        keyid: `2_${this.brandBusiness.hostid}`
                    },
                    success: data => {
                        this.setLoading(false)
                        this.writeoffCode = data.data.pageurl
                        this.$refs.writeoffCodeDialog.openDialog(data.data.posterurl, this.writeoffCode)
                    },
                    error: data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })
            }
        },
        handleSelectionChange(selection, row) {
            this.selectedId = selection
        },
        handleAllSelectionChange(selection) {
            this.handleSelectionChange(selection)
        },
        handleAllWriteoff() {
            if (!this.selectedId.length) {
                this.$message.error('请选择订单核销')
                return false
            }
            this.$confirm(`确认核销${this.selectedId.length}个订单`, '提示', {
                confirmButtonText: '确认核销',
                showCancelButton: false
            }).then(() => {
                let orderno = []
                this.selectedId.forEach(obj => {
                    orderno.push(obj.voucherid)
                })
                let obj = {
                    checkusertype: 1,
                    eventtype: 10,
                    orderno: orderno.join(',')
                }
                this._writeoff(obj)
            })
        },
        handleWriteoff(row) {
            this.$confirm(`确认核销该订单`, '提示', {
                confirmButtonText: '确认核销',
                showCancelButton: false
            }).then(() => {
                let obj = {
                    checkusertype: 1,
                    eventtype: 10,
                    orderno: row.voucherid
                }
                this._writeoff(obj)
            })
        },
        handleRowChange(row, column, event) {
            let flag = false
            this.selectedId.forEach((obj, i) => {
                if (row.voucherid == obj.voucherid) {
                    this.$refs.multipleTable.toggleRowSelection(row, false)
                    this.selectedId.splice(i, 1)
                    flag = true
                }
            })
            if (!flag) {
                this.$refs.multipleTable.toggleRowSelection(row)
                this.selectedId.push(row)
            }
        },
        handleQuery() {
            this.page.page = 1
            this._getList()
        },
        getList(status) {
            this.param.status = status
            if (!this.init) this._getList()
        },
        _refresh(status) {
            this.param.status = status
            this._getList()
        },
        _writeoff(obj) {
            this.setLoading(true)
            uploadOrderCheckResult({
                data: Object.assign({}, obj),
                success: data => {
                    this.setLoading(false)
                    this.$message.success('核销成功')
                    this.$emit('getList')
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        _getList() {
            if (this.timeSlot) {
                this.param.begintime = this.timeSlot[0]
                this.param.endtime = this.timeSlot[1]
            } else {
                this.param.begintime = ''
                this.param.endtime = ''
            }
            this.setLoading(true)
            getCheckOrderInfoListByHost({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    if (this.page.page > 1 && this.page.page > data.data.pageinfo.pageCount) {
                        this.page.page = data.data.pageinfo.pageCount
                        this._getList()
                    } else {
                        this.tableData = data.data.orderlist
                        this.total = data.data.pageinfo.rowCount
                        this.init = true
                        this.setLoading(false)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {},
    watch: {
    },
    computed: {
        status() {
            return function (value) {
                for (let i = 0; i < brandBusiness.orderStatus.length; i++) {
                    if (value === brandBusiness.orderStatus[i].code) {
                        return brandBusiness.orderStatus[i].cls
                    }
                }
                return value
            }
        },
        ...mapGetters(['params', 'brandBusiness'])
    },
    components: {
        WriteoffCodeDialog
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.bbwriteoffList {
    .filters{
        .search{
            display: flex;
            .el-input{
                margin-right: 20px;
                width: 120px;
                input{
                    width: 100%;
                }
            }
            .el-select{
                width: 100px;
                .el-input{
                    width: 100%;
                }
            }
            .el-date-editor .el-range-separator{
                line-height: 28px;
            }
            .el-range-editor.el-input__inner{
                width: 240px;
                margin-right: 20px;
            }
        }
    }
    .imageText{
        display: flex;
        .img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
    .el-pagination{
        margin-top: 20px;
        text-align: center;
    }
}
</style>
